const encode = encodeURIComponent;

export default (requests, axios) => {
    return {

        getVirutalGames: (provider, format) => {
            return requests.get(`/integration/${provider}/${format}`);
        },

        getVirutalGame: (provider, gameId) => {
            return requests.get(`/integration/${provider}/get_game?gameid=${gameId}`);
        },

        getSimpeIframeGame: (provider) => {
            return requests.get(`/integrations/${provider}/iframe`);
        },

        getIntegration: ({ provider, method }) => {
            return requests.get(`/integration/${provider}/${method}`)
        },

        getGoldenRaceGame: ({ device = 'WEB', demo = true, countryCode = '' }) => {
            return requests.get(`/integrations/goldenrace/get_game/${device.toUpperCase()}?demo=${demo}&countryCode=${countryCode}`)
        }
    }
};
